import React from 'react';
// import {Link} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Link } from "react-scroll";

const   Nav = () => {
    const { t } = useTranslation();
    return (
        <ul className="mainmenu">
            <li><Link to="home" smooth={true} offset={-70} duration={500}>Home</Link></li>
            <li><Link to="mission" smooth={true} offset={-70} duration={500}>{t('header.entrepriseMission')}</Link></li>
            <li><Link to="benefits" smooth={true} offset={-70} duration={500}>{t('header.avantages')}</Link></li>
            <li><Link to="functioning" smooth={true} offset={-70} duration={500}>{t('header.fonctionnement')}</Link></li>
            <li><Link to="offers" smooth={true} offset={-70} duration={500}>{t('header.offres')}</Link></li>
        </ul>
    )
}
export default Nav;
